
//   const result = [];

//   // Get active cards
//   const activeCards = document.querySelectorAll(
//     ".card-grid-section.active-card"
//   );

//   activeCards.forEach((card) => {
//     // Get all items
//     const multiColumns = card.querySelectorAll(".multicolumn-list__item");

//     multiColumns.forEach((multiColumn) => {
//       const sectionInfo = multiColumn.getAttribute("data-info");

//       if (sectionInfo) {
//         const sectionArray = sectionInfo
//           .split(",")
//           .map((item) => item.trim().toLowerCase());

//         result.push(...sectionArray);
//       }
//     });
//   });

//   // Make unique
//   const uniqueResult = [...new Set(result)];

//   console.log(uniqueResult);

//   // Match spans
//   const spans = document.querySelectorAll(
//     ".collection-richtext .rich-text__buttons span[data-main]"
//   );

//   let firstActiveSpan = null;

//   spans.forEach((span) => {
//     const dataMain = span
//       .getAttribute("data-main")
//       ?.trim()
//       .toLowerCase();

//     // Parent div
//     const parentDiv = span.parentElement;

//     if (parentDiv) {
//       if (uniqueResult.includes(dataMain)) {
//         parentDiv.style.display = "";

//         // Save first visible span
//         if (!firstActiveSpan) {
//           firstActiveSpan = span;
//         }
//       } else {
//         parentDiv.style.display = "none";
//       }
//     }
//   });

//   // Click first active span
//   if (firstActiveSpan) {
//     firstActiveSpan.click();
//   }




document.addEventListener("DOMContentLoaded", function () {

    const hasRequiredOptions = document.querySelector(
        'input[name="properties[Leg Height]"], ' +
        'input[name="Frame & Leg finish-2"], ' +
        'input[name="Frame & Leg finish-1"], ' +
        'input[name="Frame finish-2"], ' +
        'input[name="properties[_option_name-2]"], ' +
        '.underbed_storage_input'
    );

    if (!hasRequiredOptions) {
        return;
    }

    const leg_finishes = [
        { name: "Black stain", sku: "BL" },
        { name: "Medium Oak stain", sku: "ME" },
        { name: "Vanished stain", sku: "VA" },
        { name: "Varnished", sku: "VA" },
        { name: "Oak stain", sku: "OA" },
        { name: "Red Mahogany stain", sku: "RE" },
        { name: "Teak stain", sku: "TE" },
        { name: "English Oak stain", sku: "EN" },
        { name: "Unfinished", sku: "UN" },
        { name: "Flax linen", sku: "FL" },
        { name: "Cloud linen", sku: "CL" },
        { name: "Grey linen", sku: "GY" },
        { name: "Lagoon linen", sku: "LA" },
        { name: "Pewter linen", sku: "PE" },
        { name: "Rose linen", sku: "RO" },
        { name: "Sage linen", sku: "SA" },
        { name: "Coal cotton", sku: "CO" },
        { name: "Henna cotton", sku: "HE" },
        { name: "Azure cotton", sku: "AZ" },
        { name: "Elm cotton", sku: "EL" },
        { name: "Magnolia cotton", sku: "EL" },
        { name: "Bark velvet", sku: "BA" },
        { name: "Earth velvet", sku: "EA" },
        { name: "Grim velvet", sku: "GR" },
        { name: "Hippo velvet", sku: "HP" },
        { name: "Indigo velvet", sku: "IN" },
        { name: "Koala velvet", sku: "KO" },
        { name: "Leaf velvet", sku: "LE" },
        { name: "Ocean velvet", sku: "OC" },
        { name: "Pink velvet", sku: "PI" },
        { name: "Suede velvet", sku: "SU" },
        { name: "Tan velvet", sku: "TA" },
        { name: "Wine velvet", sku: "WI" },
        { name: "Quarry paint", sku: "QU" },
        { name: "Dawn paint", sku: "DA" },
        { name: "Yew paint", sku: "YE" },
        { name: "White paint", sku: "WH" },
        { name: "Dusk paint", sku: "DU" },
        { name: "Jacobean paint", sku: "JA" },
        { name: "Black paint", sku: "BL" },
        { name: "Neutral paint", sku: "NE" },
        { name: "Clay velour", sku: "VCL" },
        { name: "Emerald velour", sku: "VEV" },
        { name: "Iron velour", sku: "VIR" },
        { name: "Lilac velour", sku: "VLV" },
        { name: "Marine velour", sku: "VMV" },
        { name: "Mocha velour", sku: "VMC" },
        { name: "Mole velour", sku: "VML" },
        { name: "Pebble velour", sku: "VPE" },
        { name: "Smokey velour", sku: "VSM" },
        { name: "Fossil herringbone", sku: "WFO" },
        { name: "Mink herringbone", sku: "WMI" },
        { name: "Shadow herringbone", sku: "WSH" },
        { name: "Thistle herringbone", sku: "WTH" },
        { name: "Tweed herringbone", sku: "WTW" },
        { name: "Cream damask", sku: "DC1" },
        { name: "Beige damask", sku: "DC2" },
        { name: "Char damask", sku: "DC4" },
        { name: "Denim damask", sku: "DDE" },
        { name: "Sombre damask", sku: "DSO" }
    ];

    const leg_types = [
        { name: "Deco", sku: "D" },
        { name: "Medium", sku: "M", underbed: "A", height: 20 },
        { name: "Extra Tall", sku: "T", underbed: "H", height: 28 },
        { name: "Low", sku: "L" },
        { name: "Average", sku: "A", underbed: "A", height: 20 },
        { name: "Extra High", sku: "H", underbed: "H", height: 28 },
        { name: "Standard Retro", sku: "S", underbed: "A", height: 20 },
        { name: "Retro Extra High", sku: "R", underbed: "H", height: 28 },
        { name: "Cylindrical", sku: "C", underbed: "A", height: 20 },
        { name: "Pitched", sku: "P", underbed: "H", height: 28 },
        { name: "Geometric Flare", sku: "G", underbed: "A", height: 20 },
        { name: "Flare", sku: "F", underbed: "H", height: 28 }
    ];

    function setUnderbedData() {
        document.querySelectorAll(".underbed_storage_input").forEach(input => {
            const container = input.closest(".storage_products_btn");
            const image = container?.previousElementSibling?.querySelector("img");

            if (!image) return;

            const alt = image.alt.trim();

            input.dataset.boxes = alt.match(/\d+/)?.[0] || "";
            input.dataset.boxType = alt.includes("½") ? "O" : "T";
        });
    }

    function checkSelectedOptions() {

        setUnderbedData();

        const legHeight = document.querySelector(
            'input[name="properties[Leg Height]"]:checked'
        );

        const frameFinish = document.querySelector(
            'input[name="Frame & Leg finish-2"]:checked, input[name="Frame & Leg finish-1"]:checked, input[name="Frame finish-2"], input[name="Leg finish-2"]:checked'
        );

        

        const underbed = document.querySelector(
            ".underbed_storage_input:checked"
        );

        const selectedLegType = leg_types.find(
            item => item.name === legHeight?.value
        );

        const selectedFinish = leg_finishes.find(
            item => item.name === frameFinish?.value
        );

        const defaultLegHeight = document
            .querySelector(".leg-height")
            ?.getAttribute("default_leg_height");

        const selectedLegHeight =
            selectedLegType?.underbed ?? defaultLegHeight;


        // if (!selectedFinish) {
        //     console.log("No valid leg type or finish");
        //     return "";
        // }

if (!underbed) {
    // setTimeout(function () {
    // var priceEls = document.querySelectorAll('.update_price');
    // var compareEls = document.querySelectorAll('.update_price.compare_at_price');

    // function getAdditionalPrice(attribute) {
    //     var total = 0;

    //     document.querySelectorAll('.additional-price:checked').forEach(function (input) {
    //         total += parseInt(input.getAttribute(attribute), 10) || 0;
    //     });

    //     return total;
    // }

    // var addonAdd = getAdditionalPrice('data-price');
    // var addonCross = getAdditionalPrice('cross-price');

    // // Update regular price from the original base price
    // priceEls.forEach(function (el) {
    //     var basePrice = parseInt(el.getAttribute('data-base-price'), 10);

    //     if (isNaN(basePrice)) return;

    //     var newPrice = basePrice + addonAdd;

    //     el.innerHTML = Shopify.formatMoney(newPrice);
    //     el.setAttribute('data-price', newPrice);
    // });

    // // Update compare-at price from the original base price
    // compareEls.forEach(function (el) {
    //     var baseCompare = parseInt(el.getAttribute('data-base-price'), 10);

    //     if (isNaN(baseCompare)) return;

    //     var newCompare = baseCompare + addonCross;

    //     el.innerHTML = Shopify.formatMoney(newCompare);
    //     el.setAttribute('data-price', newCompare);
    // });

    // }, 900);


    // return "";
    setTimeout(window.recalcPrices, 0);
    return "";
}

console.log('selectedLegType:', selectedLegType);
console.log('defaultLegHeight:', defaultLegHeight);
console.log('selectedLegHeight:', selectedLegHeight);
        const combination =
            `${selectedLegHeight}${selectedFinish.sku}`;

        console.log("Combination:", combination);

        const boxes = underbed.dataset.boxes || "";
        const boxType = underbed.dataset.boxType || "";

        const finalValue =
            `UBS${boxType}${selectedLegHeight}${boxes}${selectedFinish.sku}`;

        console.log("FINAL:", encodeURIComponent(finalValue));

        fetch(
            `https://api.glazedigital.com/warren-evans-api/getVariantPrice.php?sku=${encodeURIComponent(finalValue)}`
        )
            .then(response => {
                console.log("Response:", response);
                return response.json();
            })
            .then(result => {

                console.log("Result:", result);

                if (result.success && result.data) {

                    const variantId = result.data.variant_id;

                    let price = result.data.price;
                    price = Math.round(parseFloat(price) * 100);

                    let compareAtPrice = result.data.compare_at_price;
                    compareAtPrice = Math.round(parseFloat(compareAtPrice) * 100);

                    underbed.value = variantId;

                    underbed.setAttribute(
                        "data-variantid",
                        variantId
                    );

                    underbed.setAttribute(
                        "data-price",
                        price
                    );

                    underbed.setAttribute(
                        "cross-price",
                        compareAtPrice
                    );

                    var selectedUnderbed = document.querySelector('.underbed_storage_input:checked');
                    var underbedAdd = selectedUnderbed ? (parseInt(selectedUnderbed.getAttribute('data-price')) || 0) : 0;
                    var underbedCross = selectedUnderbed ? (parseInt(selectedUnderbed.getAttribute('cross-price')) || 0) : 0;
                    var priceElss = document.querySelectorAll('.update_price');
                    var compareElss = document.querySelectorAll('.update_price.compare_at_price');

                    // Capture the true original base price ONCE, before anything is ever toggled
                    priceElss.forEach(function (el) {
                    if (!el.dataset.basePrice) {
                        el.dataset.basePrice = el.getAttribute('data-price');
                    }
                    });
                    compareElss.forEach(function (el) {
                    if (!el.dataset.baseCompare) {
                        el.dataset.baseCompare = el.getAttribute('data-price');
                    }
                    });

                    // All other independent add-ons (recycle/velcro etc) - can stack
                    var addonAdd = 0;
                    var addonCross = 0;
                    document.querySelectorAll('.additional-price:checked').forEach(function (input) {
                        addonAdd += parseInt(input.getAttribute('data-price')) || 0;
                        addonCross += parseInt(input.getAttribute('cross-price')) || 0;
                    });

                    var totalAdd = underbedAdd + addonAdd;
                    var totalCross = underbedCross + addonCross;

                    // priceElss.forEach(function (el) {
                    //     var base = parseInt(el.dataset.basePrice) || 0;
                    //     var newPrice = base + totalAdd;
                    //     el.innerHTML = Shopify.formatMoney(newPrice);
                    //     el.setAttribute('data-price', newPrice);
                    // });

                    // compareElss.forEach(function (el) {
                    //     var base = parseInt(el.dataset.baseCompare) || 0;
                    //     var newCompare = base + totalCross;
                    //     el.innerHTML = Shopify.formatMoney(newCompare);
                    //     el.setAttribute('data-price', newCompare);
                    // });
                    window.recalcPrices();

                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });

        return finalValue;
    }

    checkSelectedOptions();

    document.addEventListener("change", function (event) {

        if (
            event.target.matches(
                'input[name="properties[Leg Height]"], ' +
                'input[name="properties[_option_name-2]"], ' +
                'input[name="Frame & Leg finish-2"], ' +
                'input[name="Frame & Leg finish-1"], ' +
                'input[name="Frame finish-2"], ' +
                '.underbed_storage_input'
            )
        ) {

            setTimeout(() => {
                checkSelectedOptions();
            }, 0);
        }
    });
});
